import React, { useContext } from 'react'
import { ScaleContext } from '../index'
import { motion } from 'framer-motion'

export default function Header() {
	const { globalScale } = useContext(ScaleContext)
	const i = Math.floor(globalScale.length / 2)
	return (
		<header className="p-4 my-5 md:flex justify-between items-end">
			<div className="flex items-center space-x-4 mb-1 md:mb-0">
				<div
					className="w-5 h-5 rounded mt-1"
					style={{ backgroundColor: globalScale[i] }}
				></div>
				<h1 className="font-bold text-4xl">Color Maker</h1>
			</div>
			<motion.a
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 0.5, ease: 'circOut' }}
				href="https://westbrookdaniel.com/"
				target="_blank"
				rel="noopener noreferrer"
				className="mb-2 outline-none"
			>
				<p className="text-gray-400 hover:text-gray-500">Daniel Westbrook</p>
			</motion.a>
		</header>
	)
}
